<div class="header">
  <app-header-desktop class="header-desktop"></app-header-desktop>
  <app-header-mobile class="header-mobile"></app-header-mobile>
</div>
